<template>
    <widget-card>
        <div style="margin-bottom: 3.25rem">
            <div class="pro-insight-label">{{ trans('dashboard.v2.pro_insight.label') }}</div>
        </div>
        <div class="pro-insight-title">{{ trans('dashboard.v2.pro_insight.title') }}</div>
        <div class="pro-insight-desc">
            {{ trans('dashboard.v2.pro_insight.description') }}
        </div>
    </widget-card>
</template>

<script setup>
import WidgetCard from '../Components/WidgetCard.vue';
</script>

<style scoped>
.pro-insight-label {
    display: inline-block;
    background: #2563eb;
    color: #fff;
    border-radius: 999px;
    padding: 0.4375rem 0.875rem;
    align-self: flex-start;
    font-size: 0.625rem;
    font-style: normal;
    font-weight: 500;
    line-height: 0.875rem;
}
.pro-insight-title {
    color: var(--Warm-Grey, #525252);
    font-size: 1.625rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.2;
    margin-bottom: 12px;
}

.pro-insight-desc {
    font-weight: 400;
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    white-space: normal;
    color: var(--Body-Grey, #777);
    font-style: normal;
    line-height: 1.3125rem;
    font-size: 1rem;
    opacity: 0.8;
}
</style>
